// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sitemap-extra.css
   Additive styles for the Parent/Child sitemap pages.
   Import this alongside your existing sitemap.css — it only adds new
   class names and does not redeclare anything from your original file,
   so it's safe to drop in next to it. */

.sitemap-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #6b7280;
}

.sitemap-breadcrumb-current {
  color: #111827;
  font-weight: 600;
}

.sitemap-breadcrumb-sep {
  color: #9ca3af;
}

.back-button {
  margin-right: 4px;
}

.parent-info-box {
  margin-top: 4px;
  font-size: 13px;
  word-break: break-all;
  color: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/features/Sitemap/sitemap-extra.css"],"names":[],"mappings":"AAAA;;;;wCAIwC;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* sitemap-extra.css\n   Additive styles for the Parent/Child sitemap pages.\n   Import this alongside your existing sitemap.css — it only adds new\n   class names and does not redeclare anything from your original file,\n   so it's safe to drop in next to it. */\n\n.sitemap-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.sitemap-breadcrumb-current {\n  color: #111827;\n  font-weight: 600;\n}\n\n.sitemap-breadcrumb-sep {\n  color: #9ca3af;\n}\n\n.back-button {\n  margin-right: 4px;\n}\n\n.parent-info-box {\n  margin-top: 4px;\n  font-size: 13px;\n  word-break: break-all;\n  color: #4b5563;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
